import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/newLogo.png';
import './Display.css'; // Import the CSS file

const Display = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/login');
    }, 5000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [navigate]);

  return (
    <div className='displaypage flex flex-col items-center justify-center min-h-screen w-full'>
      <img 
        src={logo} 
        width={150} 
        alt="Logo" 
        className="animate-scale rounded-sm" 
      />
     
    </div>
  );
}

export default Display;
